/* eslint-disable */
import Report from "../common/icons/report";
import "./welcome.scss";
import { motion } from "framer-motion";
import MainButton from "components/common/reuseableButtonComponent/MainButton";
import DesktopDownloadIcon from "components/common/icons/desktopDownloadIcon";
import { API_HOST } from "utils/constant";
import Cookies from "js-cookie";
import { useState } from "react";

const Welcome = ({ name, action = null, user }) => {
  const myArray = name?.split(" ");
  let word = myArray ? myArray[0] : [];

  const childVariants = {
    initial: { opacity: 0, x: -50 },
    animate: { opacity: 1, x: 0 },
  };

  const [isLoading, setIsLoading] = useState(false);

  const downloadApplicationAPI = async (platformKey) => {
    try {
      setIsLoading(true); // Set loading state to true

      const fileName =
        platformKey === 1 ? "DesktopApp_Windows.exe" : "DesktopApp_MacOS.dmg";
      const url = `${API_HOST}/utils/getDesktopApp/${platformKey}`;

      const headers = {
        Pragma: "no-cache", // Required for IE 11
        Authorization: `Bearer ${Cookies.get("id_token")}`,
      };

      const response = await fetch(url, { headers });

      if (!response.ok) {
        throw new Error(`Failed to fetch file: ${response.statusText}`);
      }

      const blob = await response.blob();
      const downloadUrl = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Download failed:", error);
    } finally {
      setIsLoading(false); // Reset loading state
    }
  };

  //temp code for get os
  function getOS() {
    let userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
      windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
      iosPlatforms = ["iPhone", "iPad", "iPod"],
      os = "Unknown OS";

    if (macosPlatforms.includes(platform)) {
      os = "Mac OS";
    } else if (iosPlatforms.includes(platform)) {
      os = "iOS";
    } else if (windowsPlatforms.includes(platform)) {
      os = "Windows";
    } else if (/Android/.test(userAgent)) {
      os = "Android";
    } else if (/Linux/.test(platform)) {
      os = "Linux";
    }

    return os;
  }

  //console.log(getOS()); // Prints the OS to the console

  const downloadApplication = () => {
    if (getOS() === "Windows") {
      console.log("Downloading on Windows");
      downloadApplicationAPI(1);
    }

    if (getOS() === "Mac OS") {
      console.log("Downloading on Mac OS");
      downloadApplicationAPI(2);
    }
  };

  return (
    <>
      <div className="welcome-container">
        <div className="h-j">
          {" "}
          <motion.p
            className="welcome"
            variants={childVariants}
            initial="initial"
            animate="animate"
            transition={{
              duration: 0.6,
              delay: 0.2 * 0,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            Hi{" "}
          </motion.p>{" "}
          <motion.p
            className="welcome"
            variants={childVariants}
            initial="initial"
            animate="animate"
            transition={{
              duration: 0.6,
              delay: 0.2 * 1,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            {" "}
            {word}
          </motion.p>
        </div>
        <div className="buttons_container">
          {getOS() === "Windows" || getOS() === "Mac OS" ? (
            <div onClick={() => {!isLoading ? downloadApplication() : console.log("Loading Download")}}>
              <MainButton
                buttonText={isLoading ? "Downloading Desktop App" : "Download Desktop App"}
                ButtonIcon={DesktopDownloadIcon}
                buttonBoxShadow={true}
                buttonTooltip={
                  isLoading ? "Downloading application, please wait" :"Click here to download a desktop application for your machine"
                }
                buttonForceTooltip={true}
                buttonLoading = {isLoading}
                buttonDisabled={isLoading}
              />
            </div>
          ) : null}
          {user.permissionLevel === 1 && action && (
            <div onClick={() => action()}>
              <MainButton
                buttonText={"Pod Database"}
                ButtonIcon={Report}
                buttonBoxShadow={true}
              />
              {/* <Button value={'Pod Database'} icon={<Report/>}/> */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Welcome;
